const ASSET_BASE = "/mobility-report";

const escapeScriptJson = (value) =>
  JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/\u2028|\u2029/g, "");

const oldReportMarkup = (personLabels) => `
  <div class="app">
    <div class="screen active" id="screen1">
      <div class="list-panel">
        <div class="list-header">
          <div class="list-title">${personLabels.plural}</div>
        </div>
        <div id="patientList"></div>
      </div>
    </div>

    <div class="screen" id="screen2">
      <div class="sub-header">
        <button class="back-btn" onclick="exitReport()">‹</button>
        <div class="sub-header-title">${personLabels.singular}</div>
      </div>
      <div class="content" id="detailBody"></div>
    </div>

    <div class="screen" id="screen3">
      <div class="sub-header">
        <button class="back-btn" onclick="exitReport()">‹</button>
        <div class="sub-header-title" data-i18n="Choose Report">Choose Report</div>
      </div>
      <div class="choice-body">
        <div class="context-strip" id="choiceContext"></div>
        <div class="choice-card activity-card" id="activityCard">
          <div class="choice-label" data-i18n="Activity">Activity</div>
          <select class="activity-select" id="activitySelect"></select>
        </div>
        <div class="proceed-btn-wrap">
          <button class="generate-report-btn" onclick="goTo(4)" data-i18n="Generate Report">Generate Report</button>
        </div>
      </div>
    </div>

    <div class="screen" id="screen4">
      <div class="sub-header">
        <button class="back-btn" onclick="exitReport()">‹</button>
        <div class="sub-header-titles">
          <div class="sub-header-title" id="reportTitle">Mobility Report</div>
          <div class="sub-header-subtitle">SeniorLife.AI</div>
        </div>
      </div>
      <div class="report-body" id="reportBody"></div>
    </div>

    <div class="screen" id="screen5">
      <div class="sub-header">
        <button class="back-btn" onclick="goTo(4)">‹</button>
        <div class="sub-header-titles">
          <div class="sub-header-title" id="trendTitle">Trend</div>
          <div class="sub-header-subtitle" id="trendSubtitle"></div>
        </div>
      </div>
      <div class="trend-body" id="trendBody"></div>
    </div>

    <div class="screen" id="screen6">
      <div class="sub-header">
        <button class="back-btn" onclick="goTo(4)">‹</button>
        <div class="sub-header-title" data-i18n="Recommendations">Recommendations</div>
      </div>
      <div class="exer-body" id="exerBody"></div>
    </div>

    <button class="share-fab" id="shareFab" onclick="openShareModal()" aria-label="Share Report" data-i18n-aria="Share Report" title="Share Report">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>
    </button>
    <div class="modal-backdrop" id="modalBackdrop">
      <div class="modal-card">
        <button class="modal-x" onclick="closeModal()">×</button>
        <div class="modal-handle"></div>
        <div class="modal-title" id="modalTitle"></div>
        <div class="modal-subtitle" id="modalSubtitle"></div>
        <div class="modal-body" id="modalBody"></div>
      </div>
    </div>
    <div class="share-backdrop" id="shareBackdrop" onclick="if(event.target===this)closeShareModal()">
      <div class="share-card">
        <button class="share-x" onclick="closeShareModal()" aria-label="Close" data-i18n-aria="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <div class="share-handle"></div>
        <div class="share-title" data-i18n="Share Report">Share Report</div>
        <div class="share-subtitle" id="shareSubtitle"></div>

        <div id="sharePreviewControl" class="share-preview-btn">
          <a id="sharePreviewLink" href="#" target="_blank" rel="noopener" onclick="return prepareReportPreview(this)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            <span data-i18n="Preview Report">Preview Report</span>
          </a>
          <button type="button" id="shareCopyLinkBtn" class="share-copy-icon" onclick="copyReportLink(this)" aria-label="Copy report link" data-i18n-aria="Copy report link" title="Copy report link">
            <svg class="share-copy-glyph" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
            <svg class="share-copied-glyph" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          </button>
        </div>

        <div class="share-error" id="shareError"></div>

        <div class="share-footnote" id="shareHandoffText"></div>

        <div class="share-actions">
          <button type="button" class="share-cancel" onclick="closeShareModal()" data-i18n="Cancel">Cancel</button>
          <button type="button" class="share-send" id="shareSendBtn" onclick="submitShareReport()" disabled data-i18n="Share Report">Share Report</button>
        </div>
      </div>
    </div>
    <div class="modal-backdrop remark-backdrop" id="remarkBackdrop">
      <div class="modal-card remark-card">
        <button class="modal-x" onclick="closeRemarkModal()">×</button>
        <div class="modal-title" id="remarkTitle"></div>
        <textarea id="remarkInput" class="remark-input" rows="4" maxlength="200" placeholder="Enter here" data-i18n-placeholder="Enter here" oninput="onRemarkInput()"></textarea>
        <div class="remark-helper" id="remarkHelper"></div>
        <div class="share-error" id="remarkError"></div>
        <button id="remarkSaveBtn" onclick="submitRemark()" data-i18n="Done" disabled>Done</button>
      </div>
    </div>
    <div class="toast" id="toast"></div>
  </div>
`;

export const buildMobilityReportSrcDoc = (
  reportData,
  seniorId,
  mode = "Safety",
  previewUrl = "",
  personLabels = { singular: "Test Person", plural: "Test Persons" },
  locale = "en",
  sharedView = false,
  activityId = "",
  serverReport = null,
) => `
<!doctype html>
<html lang="${["ja", "zh"].includes(locale) ? locale : "en"}">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <link rel="stylesheet" href="${ASSET_BASE}/typography.css" />
  <link rel="stylesheet" href="${ASSET_BASE}/mobility.css" />
  <style>
    /* Embedded reports scroll at the document level. Both overflow axes must
       stay visible: hidden horizontal overflow makes visible vertical overflow
       compute to auto, trapping trackpad gestures in the growing screen. */
    .app,
    .screen.active {
      overflow: visible;
      overscroll-behavior: auto;
    }

    @media (min-width: 768px) {
      html,
      body {
        width: 100%;
        min-height: 100vh;
        padding: 0;
        background: #f1f5f9;
        display: block;
      }

      .app {
        width: 100%;
        max-width: none;
        height: auto;
        min-height: 100vh;
        margin: 0;
        border-radius: 0;
        box-shadow: none;
      }
    }

    /* Match the React app's pinned white header across every sub-screen
       (Report View, Trend, Recommendations, …) instead of only the report
       screens, so the back arrow, title and subtitle stay consistent. */
    .sub-header {
      background: #ffffff;
      color: #1e293b;
      padding: 12px 16px;
      padding-top: calc(12px + env(safe-area-inset-top, 0px));
      border-bottom: 1px solid #e2e8f0;
      gap: 12px;
    }
    .sub-header .back-btn {
      width: 40px;
      height: 40px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1e293b;
      font-size: 0;
      border-radius: 9999px;
      transition: background-color 0.2s;
    }
    .sub-header .back-btn:hover {
      background-color: #f1f5f9;
    }
    .sub-header .back-btn::before {
      content: "";
      width: 24px;
      height: 24px;
      background-color: #1e293b;
      -webkit-mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'><path d='M19 12H5m0 0l7-7m-7 7l7 7' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>") no-repeat center / contain;
              mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'><path d='M19 12H5m0 0l7-7m-7 7l7 7' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>") no-repeat center / contain;
    }
    .sub-header-title {
      font-size: var(--type-body);
      font-weight: 600;
      color: #1e293b;
      line-height: 1.3;
    }
    .sub-header-subtitle {
      font-size: var(--type-caption);
      font-weight: 500;
      color: #64748b;
      margin-top: 2px;
    }
    ${
      sharedView
        ? `
    .sub-header .back-btn,
    .share-fab,
    .remark-add-btn {
      display: none !important;
    }
    `
        : ""
    }
  </style>
</head>
<body>
  ${oldReportMarkup(personLabels)}
  <script src="${ASSET_BASE}/font-scale.js"></script>
  <script>
    function exitReport() {
      window.parent.postMessage({ type: "seniorlife:mobility-report-back" }, "*");
    }
    function openTestHistory() {
      window.parent.postMessage(
        { type: "seniorlife:mobility-report-test-history" },
        "*"
      );
    }
  </script>
  <script>
    var API_MOCK = ${escapeScriptJson(reportData)};
    var REPORT_PREVIEW_URL = ${escapeScriptJson(previewUrl)};
    // Backend v2 report document: the only source of grades, statuses,
    // trends, tiers, thresholds and freshness (see server-report.js).
    window.SERVER_REPORT = ${escapeScriptJson(serverReport)};
    var PERSON_REMARKS_LABEL = ${escapeScriptJson(
      locale === "ja"
        ? `${personLabels.singular}所見`
        : locale === "zh"
          ? `${personLabels.singular}备注`
          : `${personLabels.singular} Remarks`,
    )};
  </script>
  <script src="${ASSET_BASE}/safety_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/longevity_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/fim_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/exer_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/resident_support_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/care_support_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/pharmacy_support_logic_embedded.js"></script>
  <script src="${ASSET_BASE}/modes.js"></script>
  <script src="${ASSET_BASE}/zh-strings.js"></script>
  <script src="${ASSET_BASE}/server-report.js"></script>
  <script src="${ASSET_BASE}/app.js"></script>
  <script>
    try {
      state.patientId = ${escapeScriptJson(String(seniorId))};
      // Report type is derived from the account's customer_type (users API) and
      // injected here — there is no in-report report-type picker anymore.
      state.mode = ${escapeScriptJson(String(mode))};
      // Longevity activity: the caller's choice when it is a known activity,
      // otherwise the v95 default.
      state.activityId = (function (id) {
        return id && LONGEVITY_LOGIC.activity_library[id] ? id : "Grandparenting";
      })(${escapeScriptJson(String(activityId || ""))});
      setLocale(${escapeScriptJson(["ja", "zh"].includes(locale) ? locale : "en")});
      setMode(state.mode, false);
      goTo(4);
    } catch (error) {
      document.body.innerHTML = '<pre style="padding:16px;white-space:pre-wrap;">Unable to render report: ' + String(error && error.message || error) + '</pre>';
    }
  </script>
</body>
</html>`;
